<div class="loading-overlay" *ngIf="show() || (loadingGkService.isLoading | async)">
	<div class="loading-box">
		<span class="loading-spinner" role="status" aria-label="Cargando"></span>
	</div>
</div>
